export class CompetitorsCategories {
    genders: Set<number> = new Set();
    category: Set<string> = new Set();
    grouping: Set<string> = new Set();
    club: Set<string> = new Set();
    categoryRank?: Set<number>;
    absoluteRank?: Set<number>
    sexRank?: Set<number>;
}
